import styled from 'styled-components';
import baseInputStyle from './baseInputStyle';

const Select = styled.select`
  ${baseInputStyle}
  padding: 7px 10px;
`;

export default Select;
